import { proxyContextSafeUrl } from '../../api/index.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	managePortfolio: proxyContextSafeUrl('/jira/plans'),
	administration: proxyContextSafeUrl('/secure/PortfolioPermissions.jspa'),
	jiraHome: proxyContextSafeUrl('/jira/dashboards/last-visited'),
	manageCustomFields: proxyContextSafeUrl('/secure/admin/ViewCustomFields.jspa'),
};
